<style type="text/css">
	.el-table_1_column_7 .cell, .el-table_1_column_10 .cell{
		text-align: center;
	}
	.el-select-dropdown__item span, .el-tag .el-select__tags-text{
		text-transform: capitalize;
	}
	.el-table_1_column_6 .cell{
		padding-left: 15px !important;
	}
	.el-table .warning-row, .el-table table.el-table__body tr.el-table__row.warning-row>td{
	    background: oldlace;
	}
</style>
<style scoped>
	.content-wrapper .content{
		padding-top: 90px;
		padding-left: 5px;
		padding-right: 5px;
	}
	.heading-cart{
		position: relative;
		padding-left: 15px;
		padding-right: 15px;
	}
	.box-header .box-title {
		display: inline-block;
		font-size: 15px;
		padding: 10px;
		line-height: 1;
		color: black;
	}
	.heading-cart{
		margin-bottom: 0;
	}
	.box-body{
		padding: 0px 20px 20px;
	}
	.el-button.edit{
		padding: 5px 10px;
	}
	.select-input{
		width: 100%
	}
	.form-label{
		font-weight: bold;
		text-transform: capitalize;
	}
	button[disabled=disabled], button:disabled {
	    background-color: rgba(200,200,200,2.3);
	    border-color: rgba(200,200,200,2.3);
	    cursor: not-allowed;
	}
	.atd-box-title{
		font-size: 15px;
		padding: 10px;
		line-height: 1;
		color: black;
		border-bottom:1px solid #ececec;
	}
	.flex-order-3{
		-webkit-box-ordinal-group:4;
		-webkit-order:3;
		-ms-flex-order:3;
		order:3
	}
	.atd-add-new-field{
		margin: 0px 47px;
    	text-align: right;
	}

	.atd-remove-new-field{
		border-radius: 64%;
		padding: 0;
		border: 0;
		font-size:20px;
	}
	.atd-add-remove-container,.atd-dfp-report{
		width: 80%;
    	margin: 0 auto;
	}
	.el-input.atd-input-alias,.atd-input-site{
		margin:10px;
	}

	.atd-remove-new-field.el-button:hover {
		color: red;
		border-color: red;
		background-color: initial;
	}
	.atd-remove-new-field.el-button:focus{
		color: inherit;
		border-color: inherit;
		background-color: initial;
	}
	.atd-right-search{
		text-align: right;
		width:200px;
		display:inline-block;
	}
	.align-self-center{
		align-self:center;
	}

	.data--csv{
		cursor:pointer;
	}

</style>
<template>
	<div class="content-wrapper">
		<section class="content">
			<div class="box">
				<div class="box-header with-border heading-cart">
					<h3 class="box-title">Reports Settings</h3>
				</div>

				<div class="box-body reports-admin-panel">
					<div>
						<h3 class="atd-box-title">Site Name alias</h3>
						<template>
							<el-radio v-model="radio" label="1">Upload CSV</el-radio>
							<el-radio v-model="radio" label="2">Add single entry</el-radio>
							<div class="dis-flex" v-if="radio=='1'"><div class="p-r-10">upload csv format:</div><JsonCSV class="data--csv" :data= "jsonData" name="site-name-alias-format.csv">
              </JsonCSV></div>
							<div v-if="radio=='2'" class="atd-add-remove-container">
								<div class='atd-add-new-field'>
									<el-button v-on:click="addNewField" type="success">
										Add +
									</el-button>
								</div>
									<div v-for="(formField, index) in fields_alias" class="dis-flex">
										<el-button  v-on:click="removeField(index)" class="flex-order-3 atd-remove-new-field" icon="el-icon-remove-outline">
										</el-button>
										<el-input
										class="col-md-6 col-sm-6 col-xs-12 atd-input-alias"
											v-model="formField.alias"
											name="fields_alias[][alias]"
											placeholder="alias"
											clearable>
										</el-input>
										  <el-select v-model="formField.site"
											name="fields_alias[][site]" filterable placeholder="site" class="col-md-6 col-sm-6 col-xs-12 atd-input-site">
											<el-option
											v-for="item in publishersList"
											:key="item"
											:label="item"
											:value="item">
											</el-option>
										</el-select>
									</div>
									<el-button v-if="fields_alias.length>0" class="text-right" @click="saveAliasData()">Save</el-button>
							</div>
							<div v-else class="text-right" style="max-width: 900px;margin: 0 auto;">
								<el-upload v-loading=uploading
									class="upload-demo m-t-20"
									drag
									:limit=1
									action="reports/v1/upload/"
									:auto-upload="false"
									:http-request="upload"
									:on-preview="handlePreview"
									:on-remove="handleRemove"
									:file-list="fileList"
									ref='upload'>
									<i class="el-icon-upload"></i>
									<div class="el-upload__text">Drop file here or <em>click to upload</em></div>
								</el-upload>
								<el-button @click="submitUpload" type="success" style="margin-top:10px;">Submit</el-button>
							</div>
						</template>
						<template>
							<el-table class="atd-dfp-report"
								:data="siteAliasList"
								height="250">
									<el-table-column
									prop="alias_site_name"
									label="Alias Site Name">
									</el-table-column>
									<el-table-column
									prop="site"
									label="Site"
									>
									</el-table-column>
							</el-table>
						</template>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>
<script type="text/javascript">
	import axios from 'axios';
	import JsonCSV from 'vue-json-csv'
	export default {
		components: {JsonCSV},
		data() {
			return{
				input10:'',
				input11:'',
				UploadScreenVisible:false,
				report_date:'',
				bidder_name:'',
				frmdata:new FormData(),
				radio: '1',
				formField:{site:'',alias: ''},
				fields_alias: [{site:'',alias: ''}],
				dfpReportSitesField:{site:'',is_enabled: ''},
				allDfpReportSitesField: [{site:'',is_enabled: ''}],
				dfpReport:[],
				siteAliasList:[],
				search:'',
				jsonData:[{"SiteUrl":"","SiteAlias":""}]
			}
		},
		created: function(){
			axios.all([
			axios.get(BASE_URL+'reports/v1/all-domain-list/'),
			axios.get(BASE_URL+'reports/v1/sites-with-dfp-reports/'),
			axios.get(BASE_URL+'reports/v1/report-sites-alias/')
			]).then(axios.spread((publisher,response,alias)=>{
				this.publishersList=publisher.data
				this.dfpReport = response.data
				this.siteAliasList = alias.data
			}))

		},
		methods: {
			updateDfpReportSites:function(){
				axios.post(BASE_URL+'reports/v1/get-site-alias-list/',this.fields_alias).then(function(){

				})
			},
			saveAliasData:function(){
				axios.post(BASE_URL+'reports/v1/get-site-alias-list/',this.fields_alias).then(response=>{
					axios.get(BASE_URL+'reports/v1/report-sites-alias/').then((alias)=>{
						this.siteAliasList = alias.data
						this.fields_alias = [{site:'',alias: ''}]
					})
							console.log(response)
						})
			},
			addNewField: function () {
					this.fields_alias.push(Object.assign({}, this.formField))
					},
			removeField: function (index) {
					this.$delete(this.fields_alias, index);
			},
			getFilteredReport:function(allReportArr,domainToMatch){
				return allReportArr.filter((x)=>x['site']==domainToMatch)
			},
			getFormattedDate:function(date){
				let report_date=new Date(date)
				let dd = report_date.getDate();
				let mm = report_date.getMonth() + 1; //January is 0
				let yyyy = report_date.getFullYear();

				if (dd < 10) {
				dd = '0' + dd;
				}

				if (mm < 10) {
				mm = '0' + mm;
				}

				report_date = yyyy + '-' + mm + '-' + dd;
				return report_date
			},
			getRoundedNumbers:function(val){
				let n = Number.parseFloat(val);
				if(!val || isNaN(n) || n < 0) return 0;
				return n.toFixed(2);
			},
			cancelUploadAction:function(){
				this.$refs.upload.clearFiles()
				this.UploadScreenVisible=false
			},
			upload:function(upload){
				// this.incrementNum++
				this.frmdata.append('reportFile',upload.file)
			},
			submitUpload:function(){
				this.$refs.upload.submit();
				// this.uploadTrue='start';
				// console.log(this.report_date)
				// if(this.bidder_name == 'updated'){
				// 	this.report_date = this.default_date
				// }else{
				this.report_date = this.report_date
				// }
				this.frmdata.append('report_date',this.report_date)
				this.frmdata.append('bidder','site_alias_bulk')
				this.frmdata.append('report_type',this.reportType)
				this.uploading = true
				axios.post(BASE_URL+ 'reports/v1/upload/',this.frmdata).then(response => {
					this.uploading = false
					axios.get(BASE_URL+'reports/v1/report-sites-alias/').then((alias)=>{
						this.siteAliasList = alias.data
					})
					this.notificationMsg((response.data.status) ? 'Success' : 'Error', response.data.data.message);
					if(response.data.status == 'Success'){
						this.UploadScreenVisible = false
						this.$refs.upload.clearFiles()
					}
					else{
						this.UploadScreenVisible = false
					}
				})
				.catch(e => {
					console.log('test',e.response)
					this.uploading = false
					this.notificationMsg((e.response.data.status) ? 'Success' : 'Error', e.response.data.data.message);
					// this.UploadScreenVisible = false
				})

			},
			clearFilesList:function(){
				this.$refs.upload.clearFiles()
				this.UploadScreenVisible = false
				// clearFiles on click. dialog inside table(unique dialog for each upload button) doesn't work. hence using these functions as workaround.
			}

		}
	}
</script>


// WEBPACK FOOTER //
// ReportsConfig.vue?0931b342